import { SUBSCRIPTION_TITLE } from 'constants/subscriptions';

import { isMainSubscription } from 'helpers/subscriptions';

import { SubscriptionProductCodeTypes } from 'types/product';

const getSubscriptionName = (
    productCodeType: SubscriptionProductCodeTypes,
    isUpgrade: boolean,
    isVIPSupport?: boolean
) => {
    if (isUpgrade) return SUBSCRIPTION_TITLE.PREMIUM_PERSONALIZED_PROGRAM;

    if (isMainSubscription(productCodeType)) return SUBSCRIPTION_TITLE.PERSONALIZED_PROGRAM;

    if (isVIPSupport) return SUBSCRIPTION_TITLE.APP_VIP_SUPPORT;

    return SUBSCRIPTION_TITLE.APP_ADDITIONAL_SUBSCRIPTION;
};

export default getSubscriptionName;
